import { Shape } from 'three'
import { useVerandaSelector } from '../../../../../..'
import { Helper } from '../../../../../../classes/helper'
import { useMeasures } from '../../../../../../hooks/state/useMeasures'
import { useRoof } from '../../../../../../hooks/state/useRoof'
import { useSidewall } from '../../../../../../hooks/state/useSidewall'
import { Keys } from '../../../../../../hooks/state/utlility/utils'
import { GlassOrPolyMaterial } from './GlassOrPolyMaterial'

export const WindowsSideGlassTop = (): JSX.Element => {
  const nightMode = useVerandaSelector((state) => state.scene.nightMode)

  const {
    wedgeColor,
    sidwallTyp,
    spaceBetween,
    frameWall,
    wedgeCut,
    isPlankMaterial,
    windowColorWedge,
    wallGlasColor,
    wedgeMaterial,
  } = useSidewall()
  const { attachedSize, userAngle, schwelleSize, depth, eavesWidth, eaves } =
    useMeasures()
  const { color } = useRoof()

  const windowShape = new Shape()
  const width = spaceBetween

  const height =
    Helper.calculateTriangleSideLength(userAngle, 90, width).a +
    sidwallTyp.log.width / 2
  const wedgeHeight =
    Helper.calculateTriangleSideLength(userAngle, 90, wedgeCut).a +
    sidwallTyp.log.width / 2

  windowShape
    .moveTo(0, 0)
    .lineTo(-width, 0)
    .lineTo(-width, height + wedgeCut)
    .lineTo(-width, height + wedgeCut)
    .lineTo(0, wedgeCut + wedgeHeight)

  const extrudeSettings = {
    depth: sidwallTyp.glas,
    bevelEnabled: false,
    bevelSegments: 20,
    steps: 2,
    bevelSize: 1,
    bevelThickness: 1,
  }

  return (
    <mesh
      castShadow={true}
      position={[0, 0, (width + sidwallTyp.log.width) / 2]}
      rotation={[
        Helper.convertAngleToRadiant(0),
        Helper.convertAngleToRadiant(-90),
        Helper.convertAngleToRadiant(0),
      ]}
    >
      <extrudeGeometry
        attach="geometry"
        args={[windowShape, { ...extrudeSettings }]}
      />

      <GlassOrPolyMaterial
        isGlass={isPlankMaterial}
        roughness={windowColorWedge.roughness}
        opacity={nightMode ? 0.3 : windowColorWedge.opacity}
        isOpal={
          windowColorWedge.appearance === Keys.GlasAuswahlKeil.Values.Opal
        }
        color={wallGlasColor}
        hasPlank={wedgeMaterial.plank}
      />
    </mesh>
  )
}
